import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import * as Jquery from 'jquery';

@Directive({ selector: '[previewImage]' })
export class PreviewImageDirective implements OnInit {
    @Input() previewImage;
    @Input() rootModel;
    @Input() base64Model;

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
		const validImageTypes = ['image/png'];

		const readURL = () => {
			if (this.el.nativeElement.files && this.el.nativeElement.files[0]) {
				const fileType = this.el.nativeElement.files[0]['type'];

				if (Jquery.inArray(fileType, validImageTypes) < 0) {
				    alert('Không đúng định dạng ảnh *.png');
				    return;
				}

				const reader = new FileReader();
				reader.onload = (e: any) => {
					Jquery('#' + this.previewImage).attr('src', e.target.result);

					this.rootModel[this.base64Model] = e.target.result.split('base64,')[1];
				}
				reader.readAsDataURL(this.el.nativeElement.files[0]);
			}
		}

		Jquery(this.el.nativeElement).change(() => {
			readURL();
		});

    }
}
